import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=78952b84&scoped=true&"
import script from "./AddPage.vue?vue&type=script&lang=ts&"
export * from "./AddPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddPage.vue?vue&type=style&index=0&id=78952b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78952b84",
  null
  
)

export default component.exports